const minWidth = typeof window !== 'undefined' && window.innerWidth
const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  block: {
    display: 'block'
  },
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    height: 70
  }),
  containerMargin: {
    marginTop: 20,
  },
  buttonBase: {
    display: 'block',
    marginBottom: 16,
    paddingBottom: 8
  },
  button: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.accent,
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622',
    }
  },
  infotile: {
    backgroundColor: '#1c408c'
  },
  infotexttile: {
    backgroundColor: '#FFFFFF',
    textAlign: 'center',
    borderRight: '1px solid #cecece'
  },
  infotexttilenoborder: {
    backgroundColor: '#FFFFFF',
    textAlign: 'center'
  },
  text: {
    color: '#FFFFFF',
    fontWeight: '300',
    letterSpacing: '0.5px',
  },
  tileIcon: {
    fontSize: 70,
    color: '#FFFFFF'
  },
  heading: {
    fontSize: 20,
    marginTop: 5,
    fontWeight: 500,
  },
  tableHeader: {
    fontWeight: 900,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  testsinfotile: {
    fontSize: '3rem',
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  passsedstatus: {
    color: theme.palette.success,
  },
  failedstatus: {
    color: theme.palette.fail,
  },
  devicelicensessection: {
    marginTop: 70
  },
  error: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f44336',
    textAlign: 'center',
    height: 60
  },
  textField: {
    minWidth: '25%',
    marginLeft: '1%',
    marginRight: '1%'
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.accent,
    color: 'white',
    minWidth: 40,
    '&:hover': {
      backgroundColor: '#fd5622',
    }
  },
  deviceTextBox: {
    textAlign: 'center'
  },
  modal: {
    minWidth: 600,
    maxWidth: minWidth / 1.5
  },
  modalHeader: {
    fontWeight: '600!important',
    fontSize: '1.2rem!important',
  },
  close: {
    padding: 0,
    minWidth: 40,
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/device/styles.js